import { useTranslation } from 'react-i18next';
import type { CreateSimpleDataRequest } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormTextArea } =
  typedFormFields<CreateSimpleDataRequest>();

export const SimpleAttributes = () => {
  // Welke specificaties/attributen wil je ontvangen?
  const { t } = useTranslation('dataRequest');

  return (
    <ConditionalField
      field="attributeNote"
      condition={(fieldValue) =>
        !!fieldValue('frequency') && fieldValue('frequency')!.length > 0
      }
    >
      <FormTextArea
        fullWidth
        label={t('attributes')}
        name="attributeNote"
        showWordCount
        rules={{ maxLength: 200, minLength: 2, required: true }}
      />
    </ConditionalField>
  );
};
